export const environment = {
  production: false,
  name: "debug",
};
